import { render, staticRenderFns } from "./portfolio-frame.vue?vue&type=template&id=3adf9946&"
import script from "./portfolio-frame.vue?vue&type=script&lang=js&"
export * from "./portfolio-frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports